import React, { ReactNode, JSX } from 'react';
import { ModalBody, Modal } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useConfig, useWindow } from '@ibe/components';

export interface Props {
  isOpen: boolean;
  toggle: () => void;
  children: ReactNode | ReactNode[];
  closeOnBackdrop?: boolean;
}

const ModalLayer = (props: Props): JSX.Element => {
  const { isOpen, toggle, children, closeOnBackdrop = true } = props;
  const config = useConfig();
  const window = useWindow();

  return (
    <div className="information-layer">
      <Modal
        modalClassName={`information-layer__modal__container ${
          closeOnBackdrop ? 'information-layer__modal__container--pointer' : ''
        }`}
        className="information-layer__modal"
        isOpen={isOpen}
        container={
          config.outsideElementsContainerId
            ? window?.document?.getElementById(config.outsideElementsContainerId) || undefined
            : undefined
        }
        backdrop={closeOnBackdrop}
        toggle={toggle}
        wrapClassName={config.modalContainerClass}
      >
        <ModalBody>
          <div className="information-layer__modal__close__container">
            <button className="bg-transparent border-0 p-0">
              <FontAwesomeIcon
                onClick={toggle}
                className="information-layer__modal__close"
                icon={faTimes}
              />
            </button>
          </div>
          {children}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ModalLayer;
